import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.object.seal";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { mapGetters } from 'vuex';
export default {
  name: 'EditorialTcVars',
  props: {
    vars: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var _ref;

    return {
      tcVars: Object.seal({
        env_country: '',
        env_language: '',
        env_template: ((_ref = this.vars) != null ? _ref.env_template : _ref) || '',
        page_url: this.$route.path,
        user_category: '',
        user_email: '',
        user_firstorder_date: '',
        user_firstvisit_date: '',
        user_frequency: '',
        user_id: '',
        user_lastorder_date: '',
        user_logged: '',
        user_postalcode: '',
        user_recency: '',
        earlybirds_widgets: null
      })
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    user: 'user/me'
  })),
  created: function created() {
    var _this = this;

    this.setTcVars('init editorial');
    this.$root.$on('reset-tcvars', function () {
      _this.setTcVars('editorial reset tcVars');
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('reset-tcvars');
  },
  methods: {
    setTcVars: function setTcVars(message) {
      this.tcVars.env_country = this.locale.market;
      this.tcVars.env_language = this.locale.language;

      if (this.user && process.client) {
        this.tcVars.user_email = window.localStorage.getItem('MDM_MAIL') || '';
        this.tcVars.user_id = this.user.id;
        this.tcVars.user_category = this.$cookies.get('MDM[statut]');
        this.tcVars.user_firstvisit_date = this.$cookies.get('MDM[date_first_visit]');
      }

      if (process.client) {
        this.tcVars.earlybirds_widgets = JSON.parse(localStorage.getItem('EARLYBIRDS_WIDGETS'));
      }

      if (process.client && this.$cookies.get('debugmdm')) {
        console.log(message, _objectSpread({}, this.tcVars));
      }

      this.$root.$emit('updated-tcvars', this.tcVars);
    }
  },
  render: function render(h) {
    return h(null);
  }
};